import { render } from "./VehicleView.vue?vue&type=template&id=4970abf6&scoped=true&ts=true"
import script from "./VehicleView.vue?vue&type=script&lang=ts"
export * from "./VehicleView.vue?vue&type=script&lang=ts"

import "./VehicleView.vue?vue&type=style&index=0&id=4970abf6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4970abf6"]])

export default __exports__